(function () {
  function isWithAbValue(value) {
    var normalized = (value || '').toLowerCase();
    if (normalized.indexOf('without') !== -1) return false;
    return normalized.indexOf('with ab') !== -1 || normalized === 'with ab';
  }

  function findAbVariant(variants, currentVariantId, wantWithAb, abPosition) {
    var current = variants.find(function (variant) {
      return Number(variant.id) === Number(currentVariantId);
    });
    if (!current) return null;

    return variants.find(function (variant) {
      if (!variant.available) return false;

      for (var i = 1; i <= 3; i += 1) {
        var key = 'option' + i;
        if (i === abPosition) {
          if (wantWithAb !== isWithAbValue(variant[key])) return false;
        } else if (current[key] !== variant[key]) {
          return false;
        }
      }

      return true;
    });
  }

  function getCleanProperties(properties) {
    var clean = {};
    if (!properties) return clean;

    Object.keys(properties).forEach(function (key) {
      var value = properties[key];
      if (value != null && value !== '' && key.charAt(0) !== '_') {
        clean[key] = value;
      }
    });

    return clean;
  }

  function hasCustomProperties(lineItem) {
    return Object.keys(getCleanProperties(lineItem.properties)).length > 0;
  }

  function getVariantsNode(container) {
    var cartItem = container.closest('tr.cart-item');
    if (!cartItem) return null;
    return cartItem.querySelector('.cart-item-ab-variants-data');
  }

  function getSectionsPayload() {
    var cartDrawerItems = document.querySelector('cart-drawer-items');
    if (!cartDrawerItems || typeof cartDrawerItems.getSectionsToRender !== 'function') {
      return [];
    }

    return cartDrawerItems.getSectionsToRender().map(function (section) {
      return section.section;
    });
  }

  function refreshCartDrawerSections(parsedState) {
    var cartDrawerItems = document.querySelector('cart-drawer-items');
    if (!cartDrawerItems || !parsedState.sections) return;

    cartDrawerItems.getSectionsToRender().forEach(function (section) {
      var targetElement = document.getElementById(section.id);
      if (!targetElement || !parsedState.sections[section.section]) return;

      var sectionHtml = cartDrawerItems.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
      var replaceTarget = targetElement.querySelector(section.selector) || targetElement;
      replaceTarget.innerHTML = sectionHtml;
    });

    var cartDrawerWrapper = document.querySelector('cart-drawer');
    if (cartDrawerWrapper) {
      cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
    }

    if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-ab-option', cartData: parsedState });
    }
  }

  async function swapCartLineWithProperties(currentLine, targetVariant, sections, sectionsUrl) {
    var properties = getCleanProperties(currentLine.properties);
    var lineQuantity = currentLine.quantity;

    var addResponse = await fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: targetVariant.id,
            quantity: lineQuantity,
            properties: properties,
          },
        ],
      }),
    });

    var addData = await addResponse.json();
    if (!addResponse.ok || addData.status) {
      throw new Error(addData.description || addData.message || 'add_failed');
    }

    var changeResponse = await fetch(window.routes.cart_change_url, {
      ...fetchConfig(),
      body: JSON.stringify({
        id: currentLine.key,
        quantity: 0,
        sections: sections,
        sections_url: sectionsUrl,
      }),
    });

    return changeResponse;
  }

  async function swapCartLineAbVariant(container, wantWithAb) {
    var currentVariantId = parseInt(container.dataset.variantId, 10);
    var quantity = parseInt(container.dataset.quantity, 10);
    var abPosition = parseInt(container.dataset.abPosition, 10);
    var variantsNode = getVariantsNode(container);

    if (!variantsNode || !quantity) return;

    var variants = [];
    try {
      variants = JSON.parse(variantsNode.textContent);
    } catch (error) {
      return;
    }

    var targetVariant = findAbVariant(variants, currentVariantId, wantWithAb, abPosition);
    if (!targetVariant || Number(targetVariant.id) === currentVariantId) return;

    var toggle = container.querySelector('.cart-item-ab-option__toggle');
    container.classList.add('is-loading');
    if (toggle) toggle.disabled = true;

    var sections = getSectionsPayload();
    var sectionsUrl = window.location.pathname;

    try {
      var cart = await fetch(window.routes.cart_url + '.js').then(function (response) {
        return response.json();
      });

      var currentLine = cart.items.find(function (item) {
        return item.key === container.dataset.lineKey;
      });

      if (!currentLine) {
        var lineIndex = parseInt(container.dataset.line, 10);
        currentLine = cart.items[lineIndex - 1];
      }

      if (!currentLine) {
        throw new Error('line_not_found');
      }

      var response;
      var parsedState;

      if (hasCustomProperties(currentLine)) {
        response = await swapCartLineWithProperties(currentLine, targetVariant, sections, sectionsUrl);
      } else {
        var lineQuantity = currentLine.quantity;
        var targetQuantity = lineQuantity;
        var updates = {};

        var existingTarget = cart.items.find(function (item) {
          return Number(item.variant_id) === Number(targetVariant.id);
        });

        if (existingTarget && Number(existingTarget.variant_id) !== Number(currentLine.variant_id)) {
          targetQuantity = existingTarget.quantity + lineQuantity;
        }

        updates[currentLine.variant_id] = 0;
        updates[targetVariant.id] = targetQuantity;

        response = await fetch(window.routes.cart_update_url, {
          ...fetchConfig(),
          body: JSON.stringify({
            updates: updates,
            sections: sections,
            sections_url: sectionsUrl,
          }),
        });
      }

      var responseText = await response.text();
      parsedState = JSON.parse(responseText);

      if (!response.ok) {
        throw new Error(parsedState.description || parsedState.message || 'update_failed');
      }

      refreshCartDrawerSections(parsedState);
    } catch (error) {
      if (toggle) {
        toggle.checked = !wantWithAb;
      }
      var errors = document.getElementById('CartDrawer-CartErrors');
      if (errors) {
        errors.textContent = window.cartStrings ? window.cartStrings.error : 'Unable to update cart item.';
      }
    } finally {
      container.classList.remove('is-loading');
      if (toggle) toggle.disabled = false;
    }
  }

  document.addEventListener(
    'change',
    function (event) {
      var toggle = event.target;
      if (!toggle.classList || !toggle.classList.contains('cart-item-ab-option__toggle')) return;

      var container = toggle.closest('.cart-item-ab-option');
      if (!container) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      swapCartLineAbVariant(container, toggle.checked);
    },
    true
  );
})();
